declare let mxConstants: any;
import * as util from '../styles.util';
import {MxStyleObject} from '../styles.model';
import {StyleKeeper} from './style-keeper.model';
import {stickerCSSColorMapper} from '../../../shared/constants/color-picker.constants';

export class StickerStyleKeeper implements StyleKeeper {
  private static ColorStyleMap = stickerCSSColorMapper;

  constructor(private sticker: any) {}

  public mxCellCss() {
    const result: MxStyleObject = {
      html: 1,
      fillColor: mxConstants.NONE,
      strokeColor: mxConstants.NONE,
      fontColor: '#000000',
      fontFamily: 'sans-serif',
      fontStyle: 0,
      fontSize: 12,
      spacing: 0,
      rounded: 0,
      [mxConstants.STYLE_OVERFLOW]: 'fill',
      whiteSpace: 'wrap',
      minHeight: 50,
      minWidth: 100,
      maxHeight: 800,
      maxWidth: 800,
      paperClass: 'yellow-paper-gold'
    };

    if (this.sticker) {
      if (this.sticker.paperClass) {
        result['paperClass'] = this.sticker.paperClass;
      }

      if (this.sticker.position && this.sticker.position.rotation) {
        result['rotation'] = this.sticker.position.rotation;
      }

      if (this.sticker.locked) {
        result['locked'] = +!!+this.sticker.locked; // failsafe convert to int
      }
    }

    return util.objectToString(result, '=');
  }

  public paperStyle() {
    return this.constructor['ColorStyleMap'][this.sticker.paperClass];
  }
}
